"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateUser = exports.updateToken = exports.updateAndPatchUser = exports.setUser = exports.setPendingAvatar = exports.setDefaultTabBar = exports.setDashboardWidgets = exports.setCompany = exports.setClient = exports.setAcknowledgementDate = exports.requestResetPassword = exports.requestPostAvatar = exports.requestPatchUser = exports.requestDeleteUser = exports.refreshToken = exports.purgeSession = exports.logout = exports.loginSuccess = exports.loginSelected = exports.loginFail = exports.loginChoice = exports.login = void 0;
var types = _interopRequireWildcard(require("./types"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var login = (email, password) => ({
  type: types.REQUEST_LOGIN,
  email,
  password
});
exports.login = login;
var loginChoice = payload => ({
  type: types.REQUEST_LOGIN_CHOICE,
  payload
});
exports.loginChoice = loginChoice;
var loginFail = message => ({
  type: types.REQUEST_LOGIN_FAILED,
  message
});
exports.loginFail = loginFail;
var loginSelected = id => ({
  type: types.REQUEST_LOGIN_SELECT,
  id
});
exports.loginSelected = loginSelected;
var loginSuccess = payload => ({
  type: types.REQUEST_LOGIN_SUCCESS,
  payload
});
exports.loginSuccess = loginSuccess;
var logout = () => ({
  type: types.REQUEST_LOGOUT
});
exports.logout = logout;
var purgeSession = () => ({
  type: types.PURGE_SESSION
});
exports.purgeSession = purgeSession;
var refreshToken = () => ({
  type: types.REQUEST_REFRESH_TOKEN
});
exports.refreshToken = refreshToken;
var requestDeleteUser = () => ({
  type: types.REQUEST_DELETE_USER
});
exports.requestDeleteUser = requestDeleteUser;
var requestPatchUser = key => ({
  type: types.REQUEST_PATCH_USER,
  key
});
exports.requestPatchUser = requestPatchUser;
var requestPostAvatar = avatar => ({
  type: types.REQUEST_POST_AVATAR,
  avatar
});
exports.requestPostAvatar = requestPostAvatar;
var requestResetPassword = email => ({
  type: types.FORGOT_PASSWORD_REQUEST,
  email
});
exports.requestResetPassword = requestResetPassword;
var setAcknowledgementDate = acknowledgementDate => ({
  type: types.SET_ACKNOWLEDGEMENT_DATE,
  acknowledgementDate
});
exports.setAcknowledgementDate = setAcknowledgementDate;
var setClient = _client => ({
  type: types.SET_CLIENT,
  _client
});
exports.setClient = setClient;
var setCompany = payload => ({
  type: types.SET_COMPANY,
  payload
});
exports.setCompany = setCompany;
var setDashboardWidgets = payload => ({
  type: types.SET_DASHBOARD_WIDGETS,
  payload
});
exports.setDashboardWidgets = setDashboardWidgets;
var setDefaultTabBar = payload => ({
  type: types.SET_DEFAULT_TAB_BAR,
  payload
});
exports.setDefaultTabBar = setDefaultTabBar;
var setPendingAvatar = avatar => ({
  type: types.SET_PENDING_AVATAR,
  avatar
});
exports.setPendingAvatar = setPendingAvatar;
var setUser = user => ({
  type: types.SET_USER,
  user
});
exports.setUser = setUser;
var updateAndPatchUser = (key, value) => ({
  type: types.UPDATE_AND_PATCH_USER,
  key,
  value
});
exports.updateAndPatchUser = updateAndPatchUser;
var updateToken = token => ({
  type: types.UPDATE_TOKEN,
  token
});
exports.updateToken = updateToken;
var updateUser = (key, value) => ({
  type: types.UPDATE_USER,
  key,
  value
});
exports.updateUser = updateUser;